<template>
  <div class="list-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        class="list"
        v-model="loading"
        @load="onLoad"
        :finished="finished">
        <van-cell class="item" v-for="(item, index) in dataSource" :key="index">
          <div class="contain-bg">
            <router-link
              class="contain-bg-link"
              @click.native="saveTab"
              :to="{
                name: 'auctionDetail',
                params: { productId: item.id, status: item.status }
              }">
              <!-- top -->
              <van-cell class="top" :value="item.productName">
                <van-icon slot="right-icon" name="arrow" />
              </van-cell>

              <!-- down -->
              <div class="bottom">
                <div class="bottom-left">
                  <template v-if="item.status == 1">
                    <div class="title">预计成交日</div>
                    <div class="num">
                      {{ dateFormat(item.beginTime, "YYYY/MM/DD") }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="title">拍品到期日</div>
                    <div class="num">
                      {{ dateFormat(item.endTime, "YYYY/MM/DD") }}
                    </div>
                  </template>
                </div>
                <template v-if="item.status == 3">
                  <div class="bottom-center">
                    <div class="title">累计收益(元)</div>
                    <div class="num future">
                      {{ numFormat(item.returnAmount) }}
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="bottom-center">
                    <div class="title">预期收益(元)</div>
                    <div class="num future">
                      {{ numFormat(item.returnAmount) }}
                    </div>
                  </div>
                </template>

                <div class="bottom-right">
                  <div class="title">竞买总价(元)</div>
                  <div class="num">{{ numFormat(item.auctionPayAmount) }}</div>
                </div>
              </div>
            </router-link>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <!-- 无数据，显示空 -->
    <van-empty description="暂无记录" v-if="isShowInvest == true">
      <van-button round type="danger" class="bottom-button" @click="investClick"
        >立即投资</van-button
      >
    </van-empty>
  </div>
</template>

<script>
import { CountDown, Empty, Icon, List, PullRefresh } from "vant"
import { getAuctionInvestlist } from "../../api/auction"
import session from "../../utils/session"
export default {
  name: "auctionList",
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Icon.name]: Icon,
    [CountDown.name]: CountDown,
    [Empty.name]: Empty
  },
  props: {
    tabObject: {},
    active: 0
  },
  data() {
    return {
      dataSource: [],
      loading: false,
      finished: false,
      refreshing: false,
      isShowInvest: false, //是否显示立即投资
      form: {
        pageNo: 1,
        pageSize: 10,
        status: "",
        investType: "2"
      }
    }
  },
  beforeMount() {
    this.form.status = this.tabObject.type
  },
  watch: {},
  methods: {
    onLoad() {
      getAuctionInvestlist(this.form)
        .then((data) => {
          if (data) {
            this.loading = false
            if (this.form.pageNo === 1) {
              this.finished = false
              this.dataSource = data.list
            } else {
              this.dataSource = this.dataSource.concat(data.list)
            }
            if (data.list.length < this.form.pageSize) {
              this.finished = true
            } else {
              this.form.pageNo++
            }
            this.refreshing = false
          }
          this.onShowInvest()
        })
        .catch((e) => {
          this.loading = false
          this.refreshing = false
          this.finished = true
          this.$toast(e.msg || e.message)
          this.onShowInvest()
        })
    },
    onShowInvest() {
      if (this.dataSource) {
        if (this.dataSource.length == 0) {
          this.isShowInvest = true
        } else {
          this.isShowInvest = false
        }
      } else {
        this.isShowInvest = true
      }
    },
    onRefresh() {
      this.form.pageNo = 1
      this.onLoad()
    },
    saveTab() {
      console.log("this.active == %O", this.active)
      session.set("myauction-tab", this.active)
    },
    // 立即投资
    investClick() {
      this.$router.push("/invest")
    }
  }
}
</script>

<style lang="less" scoped>
.van-cell {
  padding: 0;
  width: auto;
  margin: 15px 15px 0 15px;
  border-radius: 8px;
}
.contain-bg {
  .contain-bg-link {
    background-color: #fff;
    display: block;
    // top
    .top {
      font-size: 15px;
      font-weight: 500;
      border-bottom: 1px dashed #ebeaea;
      padding-left: 0;
      padding-bottom: 15px;
      .van-icon {
        margin: auto;
      }
    }
    // down
    .bottom {
      margin: 15px 15px;
      display: flex;
      justify-content: space-between;
      // border: 1px solid #000000;
      .bottom-left {
        text-align: left;
      }
      .bottom-center {
        text-align: center;
      }
      .bottom-right {
        text-align: right;
      }
      .title {
        color: #666666;
      }
      .num {
        margin-top: 20px;
        color: #666666;
        font-weight: 700;
      }
      .future {
        color: #fc6524;
      }
    }
  }
}
// ----------------------
.bottom-button {
  width: 160px;
  height: 40px;
  background-color: #fc6524;
  border: none;
}
</style>